import { useReducer, useState } from 'react';

import { UserInstruction } from '../types';

// Initial state for creating a new instruction
const initialInstructionState: UserInstruction = {
  instruction_guid: '',
  title: '',
  instruction: '',
  instruction_sementics: '',
  deactivated: false,
  created_at: new Date(),
  updated_at: new Date(),
  product_sku: [],
  instance_id: [],
  isSystemInstruction: false,
};

export type UserInstructionAction =
  | { type: 'SET_ALL'; payload: UserInstruction }
  | { type: 'RESET' }
  | {
      type: 'UPDATE_FIELD';
      field: keyof UserInstruction;
      value: UserInstruction[keyof UserInstruction];
    };

function instructionReducer(
  state: UserInstruction,
  action: UserInstructionAction
): UserInstruction {
  switch (action.type) {
    case 'SET_ALL':
      return { ...action.payload };
    case 'RESET':
      return { ...initialInstructionState };
    case 'UPDATE_FIELD':
      return { ...state, [action.field]: action.value };
    default:
      return state;
  }
}

export function useInstructionReducer(initial?: UserInstruction) {
  const [formData, dispatch] = useReducer(instructionReducer, initial ?? initialInstructionState);
  const [hasError, setHasError] = useState(false);
  return [formData, dispatch, hasError, setHasError] as const;
}
